import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
import {Entity} from '../../util/uiconstants';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export function taskListReducer(state = initialState.taskList, action) {
	switch (action.type) {
		case types.GET_ALL_TASKS: {
			let allTasks = action.response.taskGroups ? action.response : {taskGroups: []};
			allTasks.apiLoaded = true;
			return {...allTasks, quickFilterId: action.quickFilterId};
		}
		case types.UPDATE_COMPLETED_TASK: {
			//Updates the status of a given taskId with the new one of the task lists.tas
			if (!action.data) return state;

			const {taskId, statusId, isEPEQRSignoffComplete, teamSummaryStatusId} = action.data;

			return (
				state.taskGroups && {
					...state,
					taskGroups: state.taskGroups.map((tg) => {
						return {
							...tg,
							tasks: tg.tasks.map((t) => {
								if (t.id === taskId) {
									return {
										...t,
										statusId: statusId,
										isEPEQRSignOffComplete: isEPEQRSignoffComplete,
										teamSummaryStatusId: teamSummaryStatusId ? teamSummaryStatusId : t.teamSummaryStatusId
									};
								} else {
									return t;
								}
							})
						};
					})
				}
			);
		}
		case types.CLEAR_TASK_LIST:
			return {};
		case types.RESET_TASK_LIST:
			return {
				availablePages: 0,
				categoryId: 0,
				engagementId: 0,
				forReviewCount: 0,
				subcategoryId: 0,
				taskAssertions: null,
				taskGroups: [],
				toPrepareCount: 0,
				totalCount: 0
			};
		case types.SELECT_ENGAGEMENT_USERROLE_ITEM:
			return {};
		case types.PUT_WCGW_TASK: {
			return updateHasWCGWAssociated(action, state, true) || state;
		}
		case types.DELETE_WCGW_TASK: {
			return updateHasWCGWAssociated(action, state, false) || state;
		}
		case types.UPDATE_DUE_DATE: {
			//Updates the due date of a given taskId with the new one of the task lists.
			if (action.payload === undefined) return state;

			let taskList = _.cloneDeep(state);
			taskList.taskGroups.forEach((tg) => {
				tg.tasks.forEach((task) => {
					if (
						action.payload.tasks.some((t) => {
							return t.id === task.id;
						})
					) {
						task.taskDueDate = action.payload.dueDate;
					}
				});
			});

			return _.cloneDeep(taskList);
		}
		case types.UPDATE_EP_EQR_SIGNOFF_INFO_TASK_LIST: {
			if (action === undefined) return state;

			let taskList = _.cloneDeep(state);
			taskList.taskGroups.forEach((tg) => {
				tg.tasks.forEach((t) => {
					if (t.id === action.data.taskId) {
						t.isEPSignoffRequired = action.data.isEPSignoffRequired;
						t.isEQRSignoffRequired = action.data.isEQRSignoffRequired;
						t.isEPSignoffUserRequired = action.data.isEPSignoffUserRequired;
						t.isEQRSignoffUserRequired = action.data.isEQRSignoffUserRequired;
					}
				});
			});

			return _.cloneDeep(taskList);
		}
		case types.GET_ALL_RESPONSIVE_TASKS: {
			let responsiveTasks = action.response ? action.response : {};
			return {...responsiveTasks};
		}
		default:
			return state;
	}
}

export function taskListReducerForWCGW(state = initialState.wcgwTasks, action) {
	switch (action.type) {
		case types.GET_ALL_TASKS_FOR_WCGW: {
			let allTasks = action.response.taskGroups ? action.response : {taskGroups: []};
			return {...allTasks};
		}
		default:
			return state;
	}
}

function updateHasWCGWAssociated(action, state, value) {
	if (
		state.taskAssertions &&
		state.taskAssertions.some((taskAssertion) => {
			return taskAssertion.taskId === action.meta.api.data.taskId;
		})
	) {
		let newState = _.cloneDeep(state);
		if (newState.taskAssertions) {
			var task = newState.taskAssertions.find((taskAssertion) => {
				return taskAssertion.taskId === action.meta.api.data.taskId;
			});

			if (task) {
				task.hasWCGWAssociated = value;

				return newState;
			}
		}
	}
}

export function taskListCountReducer(state = initialState.taskListCount, action) {
	switch (action.type) {
		case types.GET_ALL_TASKS_COUNT: {
			let allTasks = action.response.taskGroups ? action.response : {taskGroups: []};
			allTasks.apiLoaded = true;
			return {...allTasks};
		}
		case types.RESET_TASK_LIST:
			return {
				availablePages: 0,
				categoryId: 0,
				engagementId: 0,
				forReviewCount: 0,
				subcategoryId: 0,
				taskAssertions: null,
				taskGroups: [],
				toPrepareCount: 0,
				totalCount: 0
			};
		case types.SELECT_ENGAGEMENT_USERROLE_ITEM:
			return {};
		default:
			return state;
	}
}

export function buildTasksReducer(state = initialState.buildTasks, action) {
	switch (action.type) {
		case types.GET_ALL_BUILD_TASKS: {
			let allTasks = action.response.taskGroups ? action.response : {taskGroups: []};
			return {...allTasks};
		}
		default:
			return state;
	}
}

export function taskRelateUnrelateReducer(state = initialState.taskRelateUnrelate, action) {
	const entityId = action.payload ? action.payload.data : null;
	const getEntityName = (id) => Object.keys(Entity).find((key) => Entity[key] === id);
	switch (action.type) {
		case types.GET_UNRELATED_TASK: {
			return {...state, [getEntityName(entityId)]: action.response};
		}
		default:
			return state;
	}
}
